import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ActionIconsCont,
  Data,
  Name,
  HalfCont,
  Container,
  Team,
  NameCont,
  DeleteParticipantIcon,
  DeleteTeamReportIcon,
  Role,
} from './ReportsSetupMemberTile.styles';
import TableTile from '../../../HOC/TableTile/TableTile';
import { IReportsSetupMember } from '../../../services/surveys';

interface IReportsSetupMemberTile {
  member: IReportsSetupMember;
  type: string;
  deleteMember: (id: string | null) => void;
  isEffectSurvey: boolean;
}

const ReportsSetupMemberTile: FC<IReportsSetupMemberTile> = ({
  member,
  type,
  deleteMember,
  isEffectSurvey,
}) => {
  const { t } = useTranslation();
  const numOfParticipants = useMemo(() => {
    const count = member?.memberCount || 0;
    const participantsForm =
      count <= 1
        ? t('viewSurvey.reportsSetup.participants.participant')
        : t('viewSurvey.reportsSetup.participants.participants');
    return `${count} ${participantsForm}`;
  }, [member.memberCount]);
  // TODO: change members
  return (
    <TableTile isShadowed={true}>
      <Container id="Container">
        <NameCont id="NameCont">
          <Name id="Name">{member.name}</Name>
          <Data id="Data">{member.emailAddress}</Data>
        </NameCont>
        {isEffectSurvey ? (
          <HalfCont>
            <Role id="Role">
              {/* TODO: proper data from BE proper translations */}
              {t(
                `viewSurvey.reportsSetup.participants.additional.${member?.role?.toLocaleLowerCase()}`
              )}
            </Role>
          </HalfCont>
        ) : (
          <HalfCont>
            <Team id="Team">{type === 'executive' ? numOfParticipants : member?.team}</Team>
            <Data id="Data">{member.leader}</Data>
          </HalfCont>
        )}

        <ActionIconsCont id="ActionIcons">
          {type === 'team' ? (
            <DeleteParticipantIcon
              id="DeleteParticipantIcon"
              onClick={() => deleteMember(member.id)}
            />
          ) : (
            <DeleteTeamReportIcon
              id="DeleteTeamReportIcon"
              onClick={() => deleteMember(member.id)}
            />
          )}
        </ActionIconsCont>
      </Container>
    </TableTile>
  );
};

export default ReportsSetupMemberTile;
